import React, {useEffect, useRef, useState} from "react";
import FailedModal from "../../../CustomModal/Failed";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import { toast } from "react-toastify";
import Moment from "moment";
import DropDownInput from "../../../Input/dropDownInput/dropDownInput";
import useSiteDistance from "../../../../hooks/currentlocation/useSiteDistance";
import DistanceCalculatorV2 from "../../../DistanceCalculatorV2";
import distanceBetweenTwoPoints from "../../../DistanceBetweenTwoPoints";
import {generateRandomString} from "../../../Common";
import DistanceCalculator from "../../../DistanceCalculator/Calculator";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import {fireEvent} from "../../../MoEngage";
import {versionCheck} from "../../../Common";

const ActivitySave = ({
  documentUploadUrlPublic,
  newActivity,
  documentUrlDataPublic = [],
  history,
  match,
  markAttendances,
  getActivity,
  getActivityDetails = [],
  NewActivityDetails = [],
  userCheckout,
  isCheckoutDetails = [],
  markAttendanceDetails = [],
  activityTypesDetails = [],
  activityTypes,
  dealerById,
  dealerByIdDetails,
  getSenior,
  senior = [],
                        errorLogs
}) => {
  var now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  const currentUserLocation = useRef(null);
  let siteDistance = useSiteDistance(
      dealerByIdDetails?.data?.latitude,
      dealerByIdDetails?.data?.longitude
  );
  const islatlng = useLatLng();
  const [isLoading, setIsLoading] = useState(false);
  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const [countToOpenModal, setCountToOpenModal] = useState(0);
  const [inputList, setInputList] = useState([
    {
      activity_type_id: "",
      activity_date: "",
      meta_data: {},
      lat: "",
      long: "",
      next_activity_type_id: "",
      next_activity_date: "",
      description: "",
      attendance_id: "",
      module_type: "",
      dealer_id: "",
      dealer_type: "",
      tagged_along: "",
      designation: [{}, {}, {}],
    },
  ]);
  const [openCheckIn, setOpenCheckIn] = useState(false);
  const [checkInId, setCheckInId] = useState(0);
  const [isActivityCreated, setIsActivityCreated] = useState(false);
  const [checkInText, setCheckInText] = useState("Check In");
  const [activityTypeId, setActivityTypeId] = useState("");
  const [distance, setDistance] = useState(0);
  const [currentDate, setCurrentDate] = useState(
    now.toISOString().slice(0, 16)
  );
  const [purposeOfVisit, setPurposeOfVisit] = useState([{ visit_purpose: "" }]);
  const [pitched, setPitched] = useState([{ pitched: "", status: "" }]);
  const [taggedAlonedReportee, setTaggedAlonedReportee] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [showSelfie, setShowSelfie] = useState(true);
  const [hideCheckIn, setHideCheckIn] = useState(false);
  const [deviceId, setDeviceId] = useState('')
  const [isMockLocation, setIsMockLocation] = useState(false)
  const [userId, setUserId] = useState('')
  const [isLocationFetching, setIsLocationFetching] = useState(false);
  const [locationStatus, setLocationStatus] = useState(null)
  const [appVersion, setAppVersion] = useState(null);

  useEffect( async () => {
    const webView = window.localStorage?.webview;
    setAppVersion(window.localStorage?.app_version);
    if(versionCheck('3.0.0')){
      if(webView !== undefined && webView == 'true') {
        setIsLocationFetching(true);
        getUserLocation();
      } else {
        setIsLoading(true);
        setLocationStatus('granted');
        currentUserLocation.current = await getLocation();
        console.log("currentUserLocation.current", currentUserLocation.current)
        setIsLocationFetching(false);
        setIsLoading(false)
      }
    }
  }, []);

  function locationCallback(data) {
    if (data.detail) {
      if (data?.detail?.gps_status === "granted") {
        if (data.detail.status === "granted") {
          setLocationStatus("granted");
          currentUserLocation.current = {
            lat: data?.detail?.latitude,
            long: data?.detail?.longitude,
            is_mock: data.detail.mocked,
            device_id: data.detail.device_id
          }
        } else {
          setLocationStatus("permission_denied");
        }
      } else {
        setLocationStatus("gps_denied");
      }
    }
    setIsLocationFetching(false);
  }

  const getUserLocation = () => {
    let eventName = `locationEvent${generateRandomString()}`;
    window.addEventListener(eventName, locationCallback)
    window.ReactNativeWebView.postMessage(JSON.stringify({
      event_name: "get_current_location",
      data: {
        accuracy: 4,
        callback_script: `
            try {
                window.dispatchEvent(new CustomEvent('${eventName}', {detail: {
                    gps_status: "__gps_status__",
                    status: "__status__",
                    mocked: __mocked__,
                    latitude: __latitude__,
                    longitude: __longitude__,
                    device_id: "__device_id__",
                }}))
            } catch (e) {
                console.warn('could not get error')
            }
        `
      }
    }));
    return () => {
      window.removeEventListener(eventName, locationCallback)
    }
  }

  function getLocation() {

    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.permissions.query({ name: 'geolocation' }).then(permissionStatus => {
          if (permissionStatus.state === 'denied') {
            alert('Please allow location access.');
            setIsLoading(false);
            reject('Location access denied.');
            setIsLocationFetching(false);
          } else {
            setLocationStatus('granted')
            navigator.geolocation.getCurrentPosition(
                (success) => {
                  if (success?.coords && success.coords.latitude) {
                    const location = {
                      lat: success.coords.latitude,
                      long: success.coords.longitude,
                      is_mock: false,
                      device_id: ''
                    };
                    setIsLoading(false);
                    resolve(location);
                  }
                },
                (error) => {
                  setIsLoading(false);
                  reject(error);
                }
            );
          }
        }).catch(err => {
          setIsLoading(false);
          reject(err);
        });
      } else {
        setIsLoading(false);
        reject('Geolocation not supported.');
      }
    });
    setIsLoading(false);
  }

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      fireEvent('debugging_event', {
        page: window.location?.pathname,
        is_page_loading_start: 'start',
        type: 'page_loading'
      });
      setUserId(window.localStorage.user_id)
      Promise.all([
        getActivity(match?.params?.module_id),
        userCheckout(match?.params?.module_id),
        activityTypes(),
        dealerById(match?.params?.module_id, "ncd"),
        getSenior(),
      ]).then((data) => {
        setIsLoading(false);
      }).catch((error) => {
        setIsLoading(false);
      });
      setIsLoading(false);
    })();
    fireEvent('debugging_event', {
      page: window.location?.pathname,
      is_page_loading_start: 'finished',
      type: 'page_loading'
    });
  }, []);

  useEffect(() => {
    if (
      parseInt(activityTypeId) === 16 &&
      getActivityDetails?.data !== undefined
    ) {
      // if all activity is completed then show popup check in for new activity
      if (Object.keys(getActivityDetails?.data).length === 0) {
        setOpenCheckIn(true);
        setCheckInText("Check In");
      }
      // else {
      //     setActivityId(getActivityDetails?.data?.id)
      //     setCheckInText("Check Out")
      //     setIsActivityCreated(true)
      // }
    }
  }, [getActivityDetails, activityTypeId]);

  useEffect(() => {
    let values = "";
    let names = [];
    if (
      taggedAlonedReportee !== [] &&
      taggedAlonedReportee !== "" &&
      taggedAlonedReportee.length > 0
    ) {
      taggedAlonedReportee.map((val, i) => {
        names[i] = val?.name;
        if (i === 0) {
          values = val.id;
        } else {
          values += "," + val.id;
        }
      });
    }
    handleInput("tagged_along", values, "", "");
    // handleInput('meta_data', names, 'Tagged Along', '');
  }, [taggedAlonedReportee]);

  useEffect(() => {
    // after check in hide popup
    if (
      markAttendanceDetails?.data !== undefined &&
      markAttendanceDetails?.status === 200
    ) {
      setOpenCheckIn(false);
      setCheckInId(markAttendanceDetails?.data?.id);
      toast.success("Attendance is marked successfully");
      setTimeout(() => {
        setIsLoading(true);
        setIsLoading(false);
      }, 1000);
      if (checkInText === "Check out") {
        // window.location.href = `dealer-activity-list/${match?.params?.module_id}`
      }
    } else if (
      markAttendanceDetails?.data !== undefined &&
      markAttendanceDetails?.status !== 200
    ) {
      toast.warning(markAttendanceDetails?.message);
      setTimeout(() => {
        // window.location.href = `dealer-activity-list/${match?.params?.module_id}`
      }, 1000);
    }
  }, [markAttendanceDetails]);

    // const toRad = (Value) => {
    //     return Value * Math.PI / 180
    // }
    //
    // const calcCrow = (lat1, lon1, lat2, lon2) => {
    //     var R = 6371 // km
    //     var dLat = toRad(lat2 - lat1)
    //     var dLon = toRad(lon2 - lon1)
    //     var lat1 = toRad(lat1)
    //     var lat2 = toRad(lat2)
    //
    //     var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    //         Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
    //     var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    //     var d = R * c
    //     return d
    // }

    useEffect(() => {
        setHideCheckIn(false)
        if (dealerByIdDetails?.data !== undefined && dealerByIdDetails?.data?.longitude !== undefined) {
           if(versionCheck('3.0.0')){
             let distanceCal = 0;
             if(currentUserLocation?.current?.lat && currentUserLocation?.current?.long) {
               distanceCal =  distanceBetweenTwoPoints(dealerByIdDetails?.data?.latitude, currentUserLocation?.current?.lat, dealerByIdDetails?.data?.longitude, currentUserLocation?.current?.long);
             }
             setDistance(parseFloat(distanceCal).toFixed(2))
             if(currentUserLocation?.current?.is_mock){
               setIsMockLocation(true)
             }
             // else {
             //     distance = calcCrow(dealerByIdDetails?.data?.latitude, dealerByIdDetails?.data?.longitude, islatlng?.lat, islatlng?.lng)*1000
             // }

             if(distanceCal > 0.30 && checkInText === "Check In"){
               if(parseInt(userId) !== 397){
                 setHideCheckIn(true)
               }
             }
             setDistance(" " + parseFloat(distanceCal).toFixed(2))
             setTimeout(() => {
               setIsLoading(true)
               setIsLoading(false)
             }, 1000)
           }
        }
    }, [dealerByIdDetails, currentUserLocation?.current?.lat])

  useEffect(() => {
    // setHideCheckIn(false)
    if (dealerByIdDetails?.data !== undefined && dealerByIdDetails?.data?.longitude !== undefined) {
      if(!versionCheck('3.0.0')){
        let distance = 0;
        if(siteDistance?.distance_in_km !== undefined && siteDistance?.distance_in_km !== 'NaN'){
          distance = siteDistance?.distance_in_km * 1000;
        }
        // else {
        //     distance = calcCrow(dealerByIdDetails?.data?.latitude, dealerByIdDetails?.data?.longitude, islatlng?.lat, islatlng?.lng)*1000
        // }

        if(distance > 300 && checkInText === "Check In"){
          setHideCheckIn(true)
        }
        setDistance(" " + parseFloat(distance).toFixed(2) + " meter away from site")
        setTimeout(() => {
          setIsLoading(true)
          setIsLoading(false)
        }, 1000)
      }
    }
  }, [dealerByIdDetails, siteDistance])

  const handleInput = (key, val, metaKey, e, i = 0) => {
    let list = [...inputList];
    if (key === "meta_data") {
      if (e.target !== undefined && e.target.selectedOptions !== undefined) {
        let desc = e.target.selectedOptions[0].text;
        inputList[0][key][metaKey] = desc;
        inputList[0][key][metaKey + "_id"] = val;
      } else {
        inputList[0][key][metaKey] = val;
      }
    } else if (metaKey === "designation") {
        if (
          inputList[0][metaKey][i]["designation"] !== undefined &&
          inputList[0][metaKey][i]["designation"] !== val &&
          key === "Other"
        ) {
          inputList[0][metaKey][i] = {};
        }
        if (
          inputList[0][metaKey][i]["Other"] !== undefined &&
          inputList[0][metaKey][i]["Other"] !== val &&
          key === "Other"
        ) {
          delete inputList[0][metaKey][i]["others_designation"];
          delete inputList[0][metaKey][i]["name"];
          delete inputList[0][metaKey][i]["mobile_number"];
          delete inputList[0][metaKey][i]["email"];
        }
        inputList[0][metaKey][i][key] = val;
      } else {
      inputList[0][key] = val;
    }
    setInputList(list);
  };

  useEffect(() => {
    setIsFailedModalOpen(false);
    if (NewActivityDetails?.status === 200) {
      toast.success(NewActivityDetails?.message);
      if (checkInText === "Check In") {
        window.location.href = `dealer-activity-list/${match?.params?.module_id}`;
      }
      window.location.href = `dealer-activity-list/${match?.params?.module_id}`;
    } else if (
      NewActivityDetails?.status !== undefined &&
      NewActivityDetails?.status !== 200
    ) {
      setCountToOpenModal(countToOpenModal + 1);
      setIsFailedModalOpen(true);
    }
  }, [NewActivityDetails]);

    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = inputList[0]
        if (list['next_activity_type_id'] === '') {
            toast.error("Please choose activity type")
            return false
        }
        // var date = Moment(currentDate).format('Y-m-d HH:mm:ss')
        list['next_activity_date'] = currentDate

    if (list["next_activity_date"] === "") {
      toast.error("Please choose next activity date");
      return false;
    }
    var today = new Date();
    // today.setHours(today.getHours() + 3);
    today = Moment().format("Y-m-d HH:mm:ss");

    var tempDate1 = new Date(currentDate);
    var temp1 =
      tempDate1.getFullYear() +
      "-" +
      (tempDate1.getMonth() + 1) +
      "-" +
      tempDate1.getDate() +
      " " +
      tempDate1.getHours() +
      ":" +
      tempDate1.getMinutes() +
      ":" +
      tempDate1.getSeconds();
    var selectedEPOCH = tempDate1.getTime() / 1000;
    //CurrentDate
    var tempDate = new Date();
    var temp =
      tempDate.getFullYear() +
      "-" +
      (tempDate.getMonth() + 1) +
      "-" +
      tempDate.getDate() +
      " " +
      tempDate.getHours() +
      ":" +
      tempDate.getMinutes() +
      ":" +
      tempDate.getSeconds();
    var currentEPOCH = tempDate.getTime() / 1000;

    var ThreeHrMore = currentEPOCH + 10800;

        // console.log(today +" "+date+" ====  "+selectedEPOCH+" ------- "+currentEPOCH)
        if(parseInt(activityTypeId) === 15 && selectedEPOCH < ThreeHrMore) {
            toast.error("Please select time 3 hours later from current time")
            return false
        }

        list['module_type'] = 'dealer'
        list['dealer_id'] = match?.params?.module_id
        list['dealer_type'] = match?.params?.dealer_type
      if(!versionCheck('3.0.0')){
        list['lat'] = siteDistance?.curr_lat ?? islatlng?.lat
        list['long'] = siteDistance?.curr_long ?? islatlng?.lng
      } else {
        list['lat'] = currentUserLocation?.current?.lat
        list['long'] = currentUserLocation?.current?.long
      }

        list['pitched'] = pitched
        list['purpose_of_visit'] = purposeOfVisit
        // if (activityId !== 0) {
        //     list['id'] = activityId
        // }

    list["attendance_id"] = checkInId;
    if (list["long"] == null || list["lat"] == null) {
      toast.error("Please enable your location");
      return false;
    }

    if (isActivityCreated && list["next_activity_type_id"] !== "") {
      toast.error(
        "Please complete your pending activity before creating new one."
      );
      return false;
    }
    // console.log("listlistlist "+JSON.stringify(list))
    // return false
    setIsLoading(true);
    await newActivity(list);

    setIsLoading(false);
  };

  // useEffect(() => {
  //     // show check out after complete activity
  //     if (NewActivityDetails?.data !== undefined && NewActivityDetails?.status === 200) {
  //         let list = inputList[0]
  //         if (list['activity_type_id'] !== '') {
  //             setOpenCheckIn(true)
  //             setCheckInText("Check out")
  //         }
  //     }
  // }, [NewActivityDetails])

  useEffect(() => {
    // check if user already marked check in but not created any activity then allow to create when user come back
    if (isCheckoutDetails?.data  && getActivityDetails?.data) {
      if(parseInt(match?.params?.module_id) !== parseInt(isCheckoutDetails?.data?.dealer_id)){
        setTimeout(() => {
          toast.warning("Already check in on dealer id "+isCheckoutDetails?.data?.dealer_id)
          window.location.href=`dealer-activity-list/${match?.params?.module_id}`;
        }, 500)

      }
      if (isCheckoutDetails?.data?.activity_id === null && Object.keys(getActivityDetails?.data).length === 0) {
        setOpenCheckIn(false);
        setIsActivityCreated(false);
      } else if (
          isCheckoutDetails?.data?.check_out_lat === null &&
          Object.keys(getActivityDetails?.data).length === 0
      ) {
        setOpenCheckIn(true);
        setCheckInId(isCheckoutDetails?.data?.id);
        setCheckInText("Check out");
        setShowSelfie(false);
      }
    }
  }, [isCheckoutDetails, getActivityDetails]);

  useEffect(() => {
    if (
      parseInt(activityTypeId) === 16 &&
      isCheckoutDetails?.data !== undefined &&
      isCheckoutDetails?.data?.check_out_lat === null
    ) {
      setOpenCheckIn(false);
    }
  }, [activityTypeId]);

  const handlePurposeOfVisit = (val, i) => {
    let list = [...purposeOfVisit];
    list[i]["visit_purpose"] = val;
    setPurposeOfVisit(list);

    let isProduct = false;
    purposeOfVisit.map((value, i) => {
      if (
        value?.visit_purpose === "New Product" ||
        value?.visit_purpose === "New Dealer"
      ) {
        isProduct = true;
      }
    });

    // if (!isProduct) {
    //   setPitched([{ pitched: "", status: "" }]);
    // }
  };

  const handleAddPurposeOfVisit = () => {
    setPurposeOfVisit([...purposeOfVisit, { visit_purpose: "" }]);
  };

  const handleRemovePurposeOfVisit = (e, index) => {
    e.preventDefault();
    console.log(index);
    const list = [...purposeOfVisit];
    list.splice(index, 1);
    setPurposeOfVisit(list);
    let isProduct = false;
    purposeOfVisit.map((val, i) => {
      if (
        val?.visit_purpose === "New Product" ||
        val?.visit_purpose === "New Dealer"
      ) {
        isProduct = true;
      }
    });

    // if (!isProduct) {
    //   setPitched([{ pitched: "", status: "" }]);
    // }
    e.preventDefault();
  };

//   const handlePitched = (val, value, i) => {
//     let list = [...pitched];
//     list[i][val] = value;
//     setPitched(list);
//   };

//   const handleAddPitched = () => {
//     setPitched([...pitched, { pitched: "", status: "" }]);
//   };

//   const handleRemovePitched = (e, index) => {
//     const list = [...pitched];
//     list.splice(index, 1);
//     setPitched(list);
//     e.preventDefault();
//   };

  useEffect(() => {
    if(isMockLocation){
      setOpenCheckIn(false)
      setHideCheckIn(true)
      // toast.error('Location morphing is cheating. Check out not allowed');
      handleErrorLogsSave(`Location morphing is cheating. Check out not allowed`, checkInText);
      setCountToOpenModal(countToOpenModal+1);
    }
  }, [isMockLocation])

  const handleErrorLogsSave = async (msg, type) => {
    setIsLoading(true)
    await errorLogs({
      module_type:"Dealer",
      message: msg,
      type: type,
      device_id: window.localStorage.device_id ?? null
    })
    setIsLoading(false)
  }

  const refreshUserLocation = async (e) => {
    e.preventDefault();
    const webView = window.localStorage?.webview;
    if(webView !== undefined && webView == 'true') {
      setIsLocationFetching(true);
      getUserLocation();
    } else {
      setIsLoading(true);
      setIsLocationFetching(true);
      currentUserLocation.current = await getLocation();
      setIsLocationFetching(false);
      setIsLoading(false);
    }
  }

  return (
    <>
      {/*<SuccessModal*/}
      {/*    isOpen={isSuccessModalOpen}*/}
      {/*    msg={NewActivityDetails?.message}*/}
      {/*    url={''}*/}
      {/*/>*/}

      <FailedModal
        isOpen={isFailedModalOpen}
        msg={NewActivityDetails?.message}
        countToOpenModal={countToOpenModal}
      />

      {isMockLocation &&
          <FailedModal
              isOpen={isMockLocation}
              msg={`Location morphing is cheating. ${checkInText} not allowed`}
              countToOpenModal={countToOpenModal}
              url={`dealer-activity-list/${match?.params?.module_id}`}
          />
      }
      <Loader isLoading={isLoading} />

      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Activity"} history={history} />
            {/*BODY*/}

            <div className="container-fluid common-bg">
              {openCheckIn ? (
                <div className="popup-box">
                  <div className="box">
                    {!versionCheck('3.0.0')
                        ?
                        <DistanceCalculator
                            isMapShow={true}
                            calculateDistance={markAttendances}
                            moduleType={"Dealer"}
                            checkInText={checkInText}
                            moduleId={match?.params?.module_id}
                            documentUploadUrlPublic={documentUploadUrlPublic}
                            documentUrlDataPublic={documentUrlDataPublic}
                            showSelfie={showSelfie}
                            hideCheckButton={hideCheckIn}
                            distance={distance}
                            lat={dealerByIdDetails?.data?.latitude}
                            long={dealerByIdDetails?.data?.longitude}
                            dealerId={match?.params?.module_id}
                            deviceId={deviceId}
                            // deviceIdCheck={true}
                        /> :
                        <DistanceCalculatorV2
                            isMapShow={true}
                            calculateDistance={markAttendances}
                            moduleType={"Dealer"}
                            checkInText={checkInText}
                            moduleId={match?.params?.module_id}
                            documentUploadUrlPublic={documentUploadUrlPublic}
                            documentUrlDataPublic={documentUrlDataPublic}
                            showSelfie={showSelfie}
                            hideCheckButton={hideCheckIn}
                            distance={distance}
                            lat={dealerByIdDetails?.data?.latitude}
                            long={dealerByIdDetails?.data?.longitude}
                            dealerId={match?.params?.module_id}
                            deviceId={deviceId}
                            // deviceIdCheck={true}
                        />
                    }
                  </div>
                </div>
              ) : (
                <>
                  <form onSubmit={(e) => handleSubmit(e)}>
                    <div className="row">
                      <div className="col-md-12">
                        {!versionCheck('3.0.0') ?
                            <div
                                className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                              <h1 className="h3 mb-0 text-black-100">
                                <span style={{color: "green"}}>{distance}</span>
                              </h1>
                            </div> :
                            <div
                                className="d-flex align-items-center justify-content-between com-sub-heading">
                              {isLocationFetching ? "Location fetching..." : ""}
                              {locationStatus === "granted" && currentUserLocation?.current?.lat ?
                                  <span
                                      style={{color: "green"}} className="ml-5">{distance} km away from site
                                                            </span> :
                                  <h1 className="h3 mb-0 text-black-100">
                                    {/*<b>{getActivityDetails?.data?.name !== undefined ? getActivityDetails?.data?.name : "Close Activity"}</b>*/}
                                    <span
                                        style={{color: "green"}}
                                        className="ml-5"> You've denied GPS/permission, please allow it and then relaunch the
                                            application</span>
                                  </h1>
                              }
                              <button className="btn btn-primary mr-4" onClick={(e) => {
                                refreshUserLocation(e)
                              }}><i className="bi bi-arrow-clockwise f-20px"></i></button>
                            </div>
                        }

                        <div className="card-body bg-white">
                          <div className="user">
                            <div className="form-group row">
                              <div
                                  className="col-sm-6 mt-1 float-field"
                                  style={{marginTop: "16px !important"}}
                              >
                                <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      handleInput(
                                          "next_activity_type_id",
                                          e.target.value,
                                          e
                                      );
                                      setActivityTypeId(e.target.value);
                                    }}
                                >
                                  <option value="">Select Activity</option>
                                  {activityTypesDetails &&
                                      activityTypesDetails?.data !== undefined &&
                                      activityTypesDetails?.data.map((val) => {
                                        return (
                                            <>
                                              {parseInt(activityTypeId) ===
                                              val?.id ? (
                                                  <option
                                                      value={val?.id}
                                                      selected={true}
                                                  >
                                                    {val.name}
                                                  </option>
                                          ) : (
                                            <option value={val?.id}>
                                              {val.name}
                                            </option>
                                          )}
                                        </>
                                      );
                                    })}
                                </select>
                                <label className="large-label float-lb">
                                  Schedule Activity
                                </label>
                              </div>
                              <div className="col-sm-6 mtk-075 float-field">
                                <input
                                  type="datetime-local"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    handleInput(
                                      "next_activity_date",
                                      e.target.value,
                                      e
                                    );
                                    setCurrentDate(e.target.value);
                                  }}
                                  my-date-format={"DD/MM/YYYY, HH:mm:ss"}
                                  id="validationCustom01"
                                  min={
                                    new Date().toISOString().split("T")[0] +
                                    "T00:00"
                                  }
                                  value={currentDate}
                                  disabled={parseInt(activityTypeId) === 16}
                                />
                                <label className="large-label float-lb">
                                  Activity Date
                                </label>
                              </div>
                              <div className="col-sm-6 mtk-075 float-field mb-4">
                                <DropDownInput
                                  data={senior}
                                  label={"Tagged Along"}
                                  getIdValue={(val) => {
                                    setTaggedAlonedReportee(val);
                                  }}
                                  multipule={true}
                                />
                              </div>
                              {purposeOfVisit.map((val, i) => {
                                return (
                                  <>
                                    <div className="col-sm-6 mt-1 float-field">
                                      <select
                                        className="form-control form-control-user"
                                        onChange={(e) => {
                                          handlePurposeOfVisit(
                                            e.target.value,
                                            i
                                          );
                                        }}
                                        required
                                      >
                                        <option value="">
                                          Select Meeting Type
                                        </option>
                                        <option value={"New Dealer"}>
                                          New Dealer
                                        </option>
                                        <option value={"Service Dealer"}>
                                          Service Dealer
                                        </option>
                                        <option value={"Churn Dealer"}>
                                          Churn Dealer
                                        </option>
                                      </select>
                                      <label className="large-label float-lb">
                                        Meeting Type
                                      </label>
                                    </div>

                                    {(val?.visit_purpose === "Service Dealer" ||
                                      val?.visit_purpose === "Churn Dealer") && (
                                      <div
                                        className="col-sm-6 mt-1 float-field"
                                        style={{ marginTop: "16px !important" }}
                                      >
                                        <select
                                          className="form-control form-control-user"
                                          onChange={(e) => {
                                            handleInput(
                                              "designation",
                                              e.target.value,
                                              "designation",
                                              e,
                                              i
                                            );
                                          }}
                                          required={true}
                                        >
                                          <option value="">
                                            Select Meeting With
                                          </option>
                                          <option value={"Owner"}>Owner</option>
                                          <option value={"VP"}>VP</option>
                                          <option value={"GM"}>GM</option>
                                          <option value={"Sale Manager"}>
                                            Sale Manager
                                          </option>
                                          <option value={"Marketing Manager"}>
                                            Marketing Manager
                                          </option>
                                          <option value={"RTO Head"}>
                                            {" "}
                                            RTO Head
                                          </option>
                                          <option value={"Other"}>Other</option>
                                        </select>
                                        <label className="large-label float-lb">
                                          Meeting With
                                        </label>
                                      </div>
                                    )}
                                    {inputList[0]["designation"][i]?.designation !== undefined &&
                                        inputList[0]["designation"][i]?.designation === "Other" && (
                                                        <>
                                                          <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input
                                                              type="text"
                                                              className="form-control form-control-user"
                                                              placeholder=" "
                                                              onChange={(e) => {
                                                                handleInput(
                                                                  "others_designation",
                                                                  e.target
                                                                    .value,
                                                                  "designation",
                                                                  e,
                                                                  i
                                                                );
                                                              }}
                                                              required={true}
                                                            />
                                                            <label className="large-label float-lb">
                                                              Designation
                                                            </label>
                                                          </div>
                                                          <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input
                                                              type="text"
                                                              className="form-control form-control-user"
                                                              placeholder=" "
                                                              onChange={(e) => {
                                                                handleInput(
                                                                  "name",
                                                                  e.target
                                                                    .value,
                                                                  "designation",
                                                                  e,
                                                                  i
                                                                );
                                                              }}
                                                              required={true}
                                                            />
                                                            <label className="large-label float-lb">
                                                              Name
                                                            </label>
                                                          </div>
                                                          <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input
                                                              type="text"
                                                              className="form-control form-control-user"
                                                              placeholder=" "
                                                              onChange={(e) => {
                                                                const inputValue = e.target.value;
                                                                const mobileNumber = inputValue.replace(/\D/g, '');
                                                                const trimmedMobileNumber = mobileNumber.slice(0, 10)
                                                                e.target.value = trimmedMobileNumber;
                                                                handleInput("mobile_number", trimmedMobileNumber, "designation", e, i);
                                                            }}

                                                            //   onChange={(e) => {
                                                            //     handleInput(
                                                            //       "mobile_number",
                                                            //       e.target
                                                            //         .value,
                                                            //       "designation",
                                                            //       e,
                                                            //       i
                                                            //     );
                                                            //   }}
                                                              required={true}
                                                            />
                                                            <label className="large-label float-lb">
                                                              Mobile Number
                                                            </label>
                                                          </div>
                                                          <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                            <input
                                                              type="email"
                                                              className="form-control form-control-user"
                                                              placeholder=" "
                                                              onChange={(e) => {
                                                                handleInput(
                                                                  "email",
                                                                  e.target
                                                                    .value,
                                                                  "designation",
                                                                  e,
                                                                  i
                                                                );
                                                              }}
                                                              required={true}
                                                            />
                                                            <label className="large-label float-lb">
                                                              Email
                                                            </label>
                                                          </div>
                                                        </>
                                                      )}

                                    {/* {pitched.map((values, ii) => {
                                      return (
                                        <>
                                          <div className="col-md-6 float-field mtk-075 d-mtk-2">
                                            <select
                                              className="form-control form-control-user"
                                              onChange={(e) => {
                                                handlePitched(
                                                  "pitched",
                                                  e.target.value,
                                                  ii
                                                );
                                              }}
                                              required
                                            >
                                              <option value="">
                                                Select Pitched
                                              </option>
                                              <option value={"FASTag"}>
                                                FASTag
                                              </option>
                                              <option value={"Yard Management"}>
                                                Yard Management
                                              </option>
                                              <option value={"EMI Plan"}>
                                                EMI Plan
                                              </option>
                                              <option value={"Fuel"}>
                                                Fuel
                                              </option>
                                              <option value={"Pay Plus"}>
                                                Pay Plus
                                              </option>
                                              <option value={"Pickup & Drop "}>
                                                Pickup & Drop
                                              </option>
                                            </select>
                                            <label className="large-label float-lb">
                                              Pitched
                                            </label>
                                          </div>

                                          <div className="col-sm-6 mt-1 float-field">
                                            <select
                                              className="form-control form-control-user"
                                              onChange={(e) => {
                                                handlePitched(
                                                  "status",
                                                  e.target.value,
                                                  ii
                                                );
                                              }}
                                              required
                                            >
                                              <option value="">
                                                Select Status
                                              </option>
                                              <option value={"Hot"}>Hot</option>
                                              <option value={"Warm"}>
                                                Warm
                                              </option>
                                              <option value={"Cold"}>
                                                Cold
                                              </option>
                                            </select>
                                            <label className="large-label float-lb">
                                              Status
                                            </label>
                                          </div>
                                          <div className="btn-box mb-2">
                                            {pitched.length !== 1 && (
                                              <>
                                                <button
                                                  onClick={(e) =>
                                                    handleRemovePitched(e, ii)
                                                  }
                                                  className="btn btn-sm btn-danger ml-3 btn-ar"
                                                >
                                                  Remove Pitched
                                                </button>
                                              </>
                                            )}
                                            {pitched.length - 1 === ii && (
                                              <button
                                                type="button"
                                                className="btn btn-sm btn-primary ml-3 btn-ar"
                                                onClick={() =>
                                                  handleAddPitched()
                                                }
                                              >
                                                Add Pitched
                                              </button>
                                            )}
                                          </div>
                                        </>
                                      );
                                    })} */ }
                                    <div className="btn-box mb-2">
                                      {purposeOfVisit.length !== 1 && (
                                        <>
                                          <button
                                            onClick={(e) =>
                                              handleRemovePurposeOfVisit(e, i)
                                            }
                                            className="btn btn-sm btn-danger ml-3 btn-ar"
                                          >
                                            Remove Product
                                          </button>
                                        </>
                                      )}
                                      {purposeOfVisit.length - 1 === i && (
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-primary ml-3 btn-ar"
                                          onClick={() =>
                                            handleAddPurposeOfVisit()
                                          }
                                        >
                                          Another Product
                                        </button>
                                      )}
                                    </div>
                                  </>
                                );
                              })}
                              <div className="col-sm-6 mtk-075 float-field mb-4">
                                <textarea
                                  className="form-control form-control-user"
                                  placeholder=" Description"
                                  onChange={(e) => {
                                    handleInput(
                                      "description",
                                      e.target.value,
                                      "",
                                      e
                                    );
                                  }}
                                  id="validationCustom01"
                                  rows="4"
                                  cols="50"
                                  required={true}
                                />
                                <label className="large-label float-lb">
                                  {/*Description*/}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/*</div>*/}
                        <div className="col-md-12 mt-4 d-flex">
                          <button className="btn btn-primary btn-user btn-block submit-btn">
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActivitySave;
